<script setup lang="ts">
import { BuybackStrategy } from '@/types'
import { useUserStore } from '@/stores/UserStore'
import BuybackStrategyCard from './BuybackStrategyCard.vue'
import { useI18n } from 'vue-i18n'
import { toast } from 'vue-sonner'
import { Accordion } from '@/components/ui/accordion'
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'
import { Info } from 'lucide-vue-next'

const { t } = useI18n()
const user = useUserStore()

const onSuccess = (strategies: Array<BuybackStrategy>) => {
    toast.success(t('strategies.messages.strategyUpdated'))
    user.updateBuybackStrategies(strategies)
}

const onError = (message: string) => {
    toast.error(message)
}
</script>

<template>
    <div class="-mx-6 sm:-mx-8 border-b px-6 sm:px-8 pb-4">
        <h1 class="text-3xl font-bold tracking-tight flex items-center gap-2">
            {{ t('strategies.buyback.title') }}
            <Tooltip>
                <TooltipTrigger as-child>
                    <Info class="size-4 text-muted-foreground cursor-help" />
                </TooltipTrigger>
                <TooltipContent side="bottom" class="max-w-sm text-xs leading-relaxed">
                    {{ t('strategies.buyback.subTitle') }}
                </TooltipContent>
            </Tooltip>
        </h1>
    </div>

    <Accordion type="multiple" class="mt-6" :default-value="[user.buybackStrategies?.[0]?.id.toString() ?? '']">
        <BuybackStrategyCard
            v-for="strategy in user.buybackStrategies"
            :key="strategy.id"
            :strategy="strategy"
            @success="onSuccess"
            @error="onError"
        />
    </Accordion>
</template>
